import React, { useEffect, useMemo, useState } from 'react'
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, Icon, RSelect, } from '../../../components/Component';
import ReactDataTable from './ReactDataTable/ReactDataTable';
import Content from '../../../layout/content/Content';
import Head from '../../../layout/head/Head';
import ToastExample from "../../../helpers/toast";
import { getAllStores, createStore, toggleStore, deleteStore, getAllStoreCategories, updateStore, bulkUpload, deactivateStore } from "../../../redux/admin/store/action";
import { Badge, Col, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, FormText, Input, Label, Modal, ModalBody, Spinner, UncontrolledDropdown } from 'reactstrap';
import { nonActiveFormSubmissionStatus, openFormLoading } from '../../../redux/common/actions';
import * as yup from "yup";
import { string } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from 'react-hook-form';
import moment from "moment";
import { getAllCities } from '../../../redux/admin/cities/actions';
import noimage from '../../../assets/images/noimage.png'
import { IMAGE_BASE_URL, WEBSITE_API_URL, WEBSITE_BASE_URL } from '../../../config';
import { useDispatch, useSelector } from 'react-redux';
import { Image, Table } from 'antd';
import { ColorRing } from 'react-loader-spinner';

const Stores = () => {

    const dispatch = useDispatch();

    const getSelectors = (state) => ({
        stores: state.store.stores,
        cities: state.cities.cities,
        categories: state.store.store_categories,
        form_loading: state.common.form_loading,
        form_submission_status: state.common.form_submission_status,
    });

    const { stores, cities, form_loading, categories, form_submission_status, } = useSelector(getSelectors);

    // modal state
    const [modal, setModal] = useState({
        edit: false,
        add: false,
        delete: false,
        import: false,

    });
    const [toggle, setToggle] = useState({
        is_recomended: false,
        is_freedelivery: false,
        is_popular: false,
        is_featured: false,
    });
    const [formData, setFormData] = useState([]);
    const [data, setData] = useState([]);
    const [bulkHasNoData, setBulkHasNoData] = useState(false);
    const [loading, setLoading] = useState(true);

    const [file, setFile] = useState({});

    const [showToast, setShowToast] = useState(false);
    const [image, setImage] = useState([]);

    const [editingStore, setEditStore] = useState([]); // state to add and edit
    const [deletingStore, setDeleteStore] = useState([]); // for deleting store


    // function to close the form modal
    const onFormCancel = () => {
        setModal({ edit: false, add: false, delete: false, import: false });
        setToggle({
            is_featured: false,
            is_freedelivery: false,
            is_popular: false,
            is_recomended: false,
        })
        resetForm();
    };
    // function to reset the form
    const resetForm = () => {
        setFormData({
            name: "",
            phone: "",
            gst_number: "",
            store_category_id: "",
            city_id: "",
            description: "",
            offer_text: "",
            rating: "",
            approx_delivery_time: "",
            address: "",
            latitude: "",
            longitude: "",
            radius: "",
            store_charge: "",
            licence_number: "",
            commission: "",
            tax: "",
        });
    };

    // form validation schema
    const storeSchema = yup.object().shape({
        name: string().required(),
        phone: string()
            .matches(/^[6-9][0-9]{9}$/, 'Invalid phone number')
            .required('Phone number is required'),
        gst_number: string().required(),
        store_category_id: string().required(),
        city_id: string().required(),
        approx_delivery_time: string().required(),
        address: string().required(),
        latitude: string().required(),
        longitude: string().required(),
        radius: string().required(),
        store_charge: string().required(),
        licence_number: string().required(),
        commission: string().required(),
        tax: string().required(),

    });

    // schema to edit form data
    const defaultValues = useMemo(
        () => ({
            id: editingStore?.id || "",
            name: editingStore?.name || "",
            phone: editingStore?.phone || "",
            gst_number: editingStore?.gst_number || "",
            store_category_id: editingStore?.store_category_id || "",
            city_id: editingStore?.city_id || "",
            description: editingStore?.description || "",
            offer_text: editingStore?.offer_text || "",
            rating: editingStore?.rating || "",
            approx_delivery_time: editingStore?.approx_delivery_time || "",
            address: editingStore?.address || "",
            latitude: editingStore?.latitude || "",
            longitude: editingStore?.longitude || "",
            radius: editingStore?.delivery_radius_in_km || "",
            store_charge: editingStore?.store_charge || "",
            licence_number: editingStore?.license_number || "",
            commission: editingStore?.commission_rate || "",
            tax: editingStore?.tax || "",
        }),
        [editingStore]
    );

    const methods = useForm({
        resolver: yupResolver(storeSchema),
        defaultValues: defaultValues,
    });

    const {
        register,
        handleSubmit,
        setError,
        watch,
        control,
        formState: { errors },
        unregister,
        reset,
    } = methods;


    // get all stores  onload
    useEffect(() => {
        localStorage.removeItem('itemCurrentPage')
        dispatch(getAllCities());
        dispatch(getAllStoreCategories());
        dispatch(getAllStores()).then((response) => {
            if (response.payload.length > 0) {
                setLoading(false)
            }
        })

    }, [])

    // add
    const openAddModal = () => {
        setEditStore([]);
        dispatch(nonActiveFormSubmissionStatus());
        setImage(null);
        setTimeout(() => {
            setModal({ add: true });
            setToggle({
                is_featured: false,
                is_freedelivery: false,
                is_popular: false,
                is_recomended: false,
            })
        }, 100);
    };
    // edit
    const openEditModal = (store) => {
        dispatch(nonActiveFormSubmissionStatus());
        setEditStore(store);
        setImage(null);
        setTimeout(() => {
            setModal({
                edit: true
            })
            setToggle({
                is_featured: store.is_featured,
                is_freedelivery: store.is_freedelivery,
                is_popular: store.is_popular,
                is_recomended: store.is_recomended,
            })
        }, 100);
    }

    //to open delete modal
    const openDeleteModal = (store) => {
        setModal({ delete: true });
        dispatch(nonActiveFormSubmissionStatus());
        console.log(store, "sjkqsjk");
        setDeleteStore(store);
    };

    // handle bulk upload file request

    const handleFileInput = (file) => {
        console.log(file.type);
        setFile(file)
        setBulkHasNoData(false)
    };

    // submit data to api
    const onFormSubmit = (submitData) => {
        dispatch(openFormLoading());
        console.log(submitData);
        const new_data = new FormData();
        new_data.append('id', editingStore?.id);
        new_data.append('name', submitData?.name);
        new_data.append('phone', submitData?.phone);
        new_data.append('gst_number', submitData?.gst_number);
        new_data.append('store_category_id', submitData?.store_category_id);
        new_data.append('city_id', submitData?.city_id);
        new_data.append('description', submitData?.description);
        new_data.append('offer_text', submitData?.offer_text);
        new_data.append('rating', submitData?.rating);
        new_data.append('approx_delivery_time', submitData?.approx_delivery_time);
        new_data.append('address', submitData?.address);
        new_data.append('latitude', submitData?.latitude);
        new_data.append('longitude', submitData?.longitude);
        new_data.append('radius', submitData?.radius);
        new_data.append('store_charge', submitData?.store_charge);
        new_data.append('license_number', submitData?.licence_number);
        new_data.append('commission', submitData?.commission);
        new_data.append('tax', submitData?.tax);
        new_data.append('is_popular', toggle.is_popular ? 1 : 0);
        new_data.append('is_recomended', toggle.is_recomended ? 1 : 0);
        new_data.append('is_freedelivery', toggle.is_freedelivery ? 1 : 0);
        new_data.append('is_featured', toggle.is_featured ? 1 : 0);
        if (image) {
            new_data.append('image', image);
        }
        if (modal.edit) {
            dispatch(updateStore(new_data));
        }
        else if (modal.add) {
            dispatch(createStore(new_data));
        }
        else if (modal.delete) {
            dispatch(deleteStore(deletingStore?.id));
        }
    };


    // submit data for bulk upload
    const onFormBulkUpload = (e) => {
        e.preventDefault();
        const token = localStorage.getItem('accessToken');

        if (file) {
            dispatch(bulkUpload(file)).then(response => {
                if (response.payload.success && response.payload.message == "UPLOADED") {
                    setModal({ import: false })
                    setShowToast(true);
                    setTimeout(() => {
                        setShowToast(false);
                    }, 3000);
                } else if (response.payload.success && response.payload.message == "NODATA") {
                    setBulkHasNoData(true)
                }

            })

        }
    };

    // useEffect which watches the formsubmission of delete and create.
    useEffect(() => {
        if (modal.add == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllStores());
                setData(stores);
                setModal({ add: false });
                setToggle({
                    is_featured: false,
                    is_freedelivery: false,
                    is_popular: false,
                    is_recomended: false,
                })
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }
        if (modal.edit == true && editingStore && form_loading == false && form_submission_status == true) {
            dispatch(getAllStores());
            setData(stores);
            setModal({ edit: false });
            setToggle({
                is_featured: false,
                is_freedelivery: false,
                is_popular: false,
                is_recomended: false,
            })
            setShowToast(true);
            reset(defaultValues);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        } else {
            reset(defaultValues);
        }
        if (modal.delete == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllStores());
                setData(stores);
                setModal({ delete: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }
    }, [createStore, form_loading, modal, form_submission_status]);


    const dataTableColumns = [
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Image",
            selector: (row) => row.image,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <Image
                        style={{
                            height: "15vh",
                            width: "15vh",
                            objectFit: 'cover',
                        }}
                        src={row?.image ? row?.image : noimage}
                    />
                </div>
            )
        },
        {
            name: "Phone",
            selector: (row) => row.phone,
            sortable: true,
        },
        {
            name: "Items",
            selector: (row) => row.items,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <DropdownItems row={row} />
                </div>
            )
        },
        {
            name: "Status",
            selector: (row) => row.startDate,
            cell: (row) => (
                <Button color={row?.is_active ? "success" : "danger"} onClick={(e) => {
                    handleStoreStatus(e, row?.id)
                }}>
                    {row?.is_active ? <Icon name="stop-circle-fill" /> : <Icon name="play-circle-fill" />}
                </Button>
            )
        },
        {
            name: "Deactivate",
            selector: (row) => row.is_running,
            cell: (row) => (
                <Button color={row?.is_running ? "success" : "danger"} onClick={(e) => {
                    handleStoreActivation(e, row?.id)
                }}>
                    {row?.is_active ? <Icon name="stop-circle-fill" /> : <Icon name="play-circle-fill" />}
                </Button>
            )
        },
        {
            name: "Action",
            selector: (row) => row.salary,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <DropdownTrans row={row} />
                </div>
            )
        },
    ];

    const DropdownTrans = ({ row }) => {
        return (
            <UncontrolledDropdown>
                <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                    <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                    <ul className="link-list-plain">
                        <li>
                            <DropdownItem tag="a" onClick={(e) => { openEditModal(row) }}>
                                <Icon name="pen" />Edit
                            </DropdownItem>
                        </li>
                        <li>
                            <DropdownItem
                                tag="a"
                                href="#dropdownitem"
                                onClick={(e) => { openDeleteModal(row) }}
                            >
                                <Icon name="trash" />Delete
                            </DropdownItem>
                        </li>

                    </ul>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    };

    const DropdownItems = ({ row }) => {
        return (
            <UncontrolledDropdown>
                <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                    <Icon name="opt-dot-alt" />
                </DropdownToggle>
                <DropdownMenu right>
                    <ul className="link-list-plain">
                        <li>
                            <DropdownItem tag="a" href={"/store-item-categories/" + row.id}>
                                <Icon name="link" />
                                Item Categories
                            </DropdownItem>
                        </li>
                        <li>
                            <DropdownItem tag="a" href={"/store-items/" + row.id}>
                                <Icon name="link" />
                                Items
                            </DropdownItem>
                        </li>
                        <li>
                            <DropdownItem tag="a" href={"/store-addon-categories/" + row.id}>
                                <Icon name="link" />
                                Addon Categories
                            </DropdownItem>
                        </li>
                        <li>
                            <DropdownItem tag="a" href={"/sort-item-categories/" + row.id}>
                                <Icon name="filter" />
                                Sort Item Categories
                            </DropdownItem>
                        </li>
                        <li>
                            <DropdownItem tag="a" href={"/sort-items/" + row.id}>
                                <Icon name="filter" />
                                Sort Items
                            </DropdownItem>
                        </li>
                    </ul>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    };



    // to handle status
    const handleStoreStatus = (e, id) => {
        dispatch(toggleStore(id));
        setTimeout(() => {
            dispatch(getAllStores());
            setShowToast(true);
        }, 500);

        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    };

    const handleStoreActivation = (e, id) => {
        dispatch(deactivateStore(id));
        setTimeout(() => {
            dispatch(getAllStores());
            setShowToast(true);
        }, 500);

        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    };

    const listCity = cities?.map((city) => (
        { value: city.id, label: city.name }

    ));

    const listCategory = categories?.map((category) => (
        { value: category.id, label: category.name }

    ));

    return (
        <React.Fragment>
            {loading ? (
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
            ) :
                <React.Fragment>
                    <Head title="Stores"></Head>

                    <Content>
                        <BlockHead size="sm">
                            <BlockBetween>
                                <BlockHeadContent>
                                    <BlockTitle tag="h3" page>
                                        Store Lists
                                    </BlockTitle>
                                    <BlockDes className="text-soft">
                                        <p>You have total {stores.length} stores.</p>
                                    </BlockDes>
                                </BlockHeadContent>
                                <BlockHeadContent>
                                    <div className="toggle-wrap nk-block-tools-toggle">
                                        <ToastExample show={showToast} />
                                        <div className="toggle-expand-content" >
                                            <ul className="nk-block-tools g-3">
                                                <li>
                                                    <a href="/sort-stores"
                                                        className="btn btn-white btn-outline-light"  >
                                                        <Icon name="filter"></Icon>
                                                        <span>Sort Stores</span>
                                                    </a>
                                                </li>
                                                <li>
                                                    <div
                                                        onClick={(ev) => {
                                                            ev.preventDefault();
                                                            setModal({ import: true })
                                                        }}
                                                        className="btn btn-white btn-outline-light"
                                                    >
                                                        <Icon name="upload-cloud"></Icon>
                                                        <span>Bulk Upload</span>
                                                    </div>
                                                </li>

                                                <li>
                                                    <a href="/pending-stores"
                                                        className="btn btn-dark btn-outline-dark text-white"
                                                    >
                                                        <span>Pending Stores </span>
                                                    </a>
                                                </li>
                                                <li className="nk-block-tools-opt">
                                                    <Button color="primary" className="btn-icon"
                                                        onClick={() => openAddModal()}
                                                    >
                                                        <Icon name="plus"></Icon>
                                                    </Button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </BlockHeadContent>
                            </BlockBetween>
                        </BlockHead>
                        <ReactDataTable data={stores} columns={dataTableColumns} expandableRows pagination />

                    </Content>

                    {/* add modal */}
                    <Modal
                        isOpen={modal.add || modal.edit}
                        toggle={() => {
                            setModal({ add: false });
                            setToggle({
                                is_featured: false,
                                is_freedelivery: false,
                                is_popular: false,
                                is_recomended: false,
                            })
                        }}
                        className="modal-dialog-centered"
                        size="lg"
                    >
                        <ModalBody>
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">{modal.edit ? "Editing Store  - " + editingStore?.name : "Add Store"}</h5>
                                <div className="mt-4">
                                    <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)} >
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Store Name</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="name"
                                                    placeholder="Enter Store Name"
                                                    ref={register({ required: "This field is required" })}
                                                />
                                                {errors.name && <span className="invalid">{errors.name.message}</span>}
                                            </FormGroup>
                                        </Col>

                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" >Image </label>
                                                <input
                                                    className="form-control"
                                                    type="file"
                                                    name="image"
                                                    accept="image/png, image/jpeg, image/jpg"
                                                    onChange={(e) => {
                                                        setImage(e.target.files[0])
                                                    }}
                                                />
                                                {errors.image && <span className="invalid">{errors.image.message}</span>}
                                                {/* <FormText>upload resolution 250x250 pixel</FormText> */}
                                            </FormGroup>
                                        </Col>
                                        <Col md="12" style={modal.edit ? { display: 'block' } : { display: 'none' }}>
                                            <FormGroup>
                                                <label className="form-label">Current Image </label>
                                                <div className="" id={editingStore.id}>
                                                    {editingStore?.image ?
                                                        <Image
                                                            style={{
                                                                objectFit: 'cover', height: '20vh'
                                                            }}
                                                            src={editingStore?.image}
                                                        />
                                                        :
                                                        <>
                                                            <img src={noimage} alt="item category" style={{ height: '7vh', width: '7vh' }} />
                                                            <span className='m-1' style={{ color: '#330033', fontSize: '9px' }}>No image found</span>
                                                        </>
                                                    }
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Phone</label>
                                                <input
                                                    className="form-control"
                                                    type="tel"
                                                    name="phone"
                                                    placeholder="Enter Phone Number"
                                                    ref={register({ required: "This field is required" })}
                                                />
                                                {errors.phone && <span className="invalid">{errors.phone.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">GST Number</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="gst_number"
                                                    placeholder="Enter GST Number"
                                                    ref={register({ required: "This field is required" })}
                                                />
                                                {errors.gst_number && <span className="invalid">{errors.gst_number.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Store Category</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="store_category_id"
                                                        control={control}
                                                        render={({ onChange, value, ref }) => (
                                                            <RSelect
                                                                options={listCategory}
                                                                onChange={(val) => onChange(val.value)}
                                                                defaultValue={listCategory.find((c) => c.value === value)}
                                                            />
                                                        )}
                                                    // ref={register({ required: "This field is required" })}
                                                    />
                                                    {errors.store_category_id && (
                                                        <span className="invalid text-danger text-italic">Please choose a store category</span>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">City</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="city_id"
                                                        control={control}
                                                        render={({ onChange, value, ref }) => (
                                                            <RSelect
                                                                options={listCity}
                                                                onChange={(val) => onChange(val.value)}
                                                                defaultValue={listCity.find((c) => c.value === value)}
                                                            />
                                                        )}
                                                    // ref={register({ required: "This field is required" })}
                                                    />
                                                    {errors.city_id && (
                                                        <span className="invalid text-danger text-italic">Please choose a city</span>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Description</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="description"
                                                    placeholder="Enter a description"
                                                    ref={register()}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Offer Text</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="offer_text"
                                                    placeholder="Enter Offer Text"
                                                    ref={register()}
                                                />
                                                {errors.offer_text && <span className="invalid">{errors.offer_text.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Rating</label>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    min="1"
                                                    max="5"
                                                    name="rating"
                                                    placeholder="Enter Rating"
                                                    ref={register()}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Approx Delivery Time</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="approx_delivery_time"
                                                    placeholder="Enter Approx Delivery Time"
                                                    ref={register({ required: "This field is required" })}
                                                />
                                                {errors.approx_delivery_time && <span className="invalid">{errors.approx_delivery_time.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Address</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="address"
                                                    placeholder="Enter Address"
                                                    ref={register({ required: "This field is required" })}
                                                />
                                                {errors.address && <span className="invalid">{errors.address.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Latitude </label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="latitude"
                                                    placeholder="Enter City Latitude"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                />
                                                {errors.latitude && <span className="invalid">{errors.latitude.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Longitude</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="longitude"
                                                    placeholder="Enter City Longitude"
                                                    ref={register({ required: "This field is required" })}
                                                />
                                                {errors.longitude && <span className="invalid">{errors.longitude.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Radius</label>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    name="radius"
                                                    min="0"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                    placeholder="Enter city maximum delivery radius"
                                                />
                                                {errors.radius && <span className="invalid">{errors.radius.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Store Charge</label>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    min="0"
                                                    name="store_charge"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                    placeholder="Enter Store Charge"
                                                />
                                                {errors.store_charge && <span className="invalid">{errors.store_charge.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Licence Number</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="licence_number"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                    placeholder="Enter Licence Number"
                                                />
                                                {errors.licence_number && <span className="invalid">{errors.licence_number.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Commission</label>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    min="0"
                                                    max="100"
                                                    name="commission"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                    placeholder="Enter Commission %"
                                                />
                                                {errors.commission && <span className="invalid">{errors.commission.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Tax</label>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    min="0"
                                                    name="tax"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                    placeholder="Enter Tax"
                                                />
                                                {errors.tax && <span className="invalid">{errors.tax.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="12">
                                            <FormGroup >
                                                <div className="custom-control custom-switch">
                                                    <input type="checkbox" className="custom-control-input" checked={toggle.is_popular} id="is_popular" onChange={() => {
                                                        setToggle({
                                                            ...toggle,
                                                            is_popular: !toggle.is_popular
                                                        });

                                                    }} />
                                                    <label className="custom-control-label" htmlFor="is_popular"> Is Popular </label>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="12">
                                            <FormGroup>
                                                <div className="custom-control custom-switch">
                                                    <input type="checkbox" className="custom-control-input" checked={toggle.is_recomended} id="is_recommended" onChange={() => {
                                                        setToggle({
                                                            ...toggle,
                                                            is_recomended: !toggle.is_recomended
                                                        });

                                                    }} />
                                                    <label className="custom-control-label" htmlFor="is_recommended"> Is Recommended </label>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="12">
                                            <FormGroup>
                                                <div className="custom-control custom-switch">
                                                    <input type="checkbox" className="custom-control-input" checked={toggle.is_freedelivery} id="is_freedelivery" onChange={() => {
                                                        setToggle({
                                                            ...toggle,
                                                            is_freedelivery: !toggle.is_freedelivery
                                                        });
                                                    }} />
                                                    <label className="custom-control-label" htmlFor="is_freedelivery"> Is FreeDelivery </label>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="12">
                                            <FormGroup>
                                                <div className="custom-control custom-switch">
                                                    <input type="checkbox" className="custom-control-input" checked={toggle.is_featured} id="is_featured" onChange={() => {
                                                        setToggle({
                                                            ...toggle,
                                                            is_featured: !toggle.is_featured
                                                        });
                                                    }} />
                                                    <label className="custom-control-label" htmlFor="is_featured"> Is Featured </label>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="12">
                                            <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                                <li>
                                                    <Button type="submit" color="primary" size="lg" className="btn-block">
                                                        {form_loading ? (
                                                            <>
                                                                <Spinner size="sm" color="light" /> Creating New Store
                                                            </>
                                                        ) : (
                                                            <React.Fragment>{modal.edit ? "Update Store" : "Add New Store"}</React.Fragment>
                                                        )}
                                                    </Button>
                                                </li>
                                                <li>
                                                    <a
                                                        href="#cancel"
                                                        onClick={(ev) => {
                                                            ev.preventDefault();
                                                            onFormCancel();
                                                        }}
                                                        className="link link-light"
                                                    >
                                                        Cancel
                                                    </a>
                                                </li>
                                            </ul>
                                        </Col>
                                    </Form>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                    {/* delete modal */}
                    <Modal
                        isOpen={modal.delete}
                        toggle={() => setModal({ add: false })}
                        className="modal-dialog-centered"
                    >
                        <ModalBody className="pt-3 pb-2">
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">
                                    Delete Store <Badge color="primary">{deletingStore?.name}</Badge> ?

                                </h5>
                                <div className="mt-2">
                                    <span>This store will be deleted. Do you really want to delete this store ?</span>
                                </div>
                                <div className="mt-3">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4">
                                        <li>
                                            <Button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    onFormSubmit();
                                                }}
                                                color="danger"
                                                className="px-4 btn-block"
                                            >
                                                {form_loading ? (
                                                    <>
                                                        <Spinner size="sm" color="light" />
                                                        Deleting
                                                    </>
                                                ) : (
                                                    <React.Fragment>Delete</React.Fragment>
                                                )}
                                            </Button>
                                        </li>
                                        <li>
                                            <a
                                                href="#cancel"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                    onFormCancel();
                                                }}
                                                className="link link-light"
                                            >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>

                    {/* import modal */}
                    <Modal
                        isOpen={modal.import}
                        toggle={() => setModal({ import: false })}
                        className="modal-dialog-centered"
                    >
                        <ModalBody className="pt-3 pb-2">
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">
                                    Bulk Upload Stores

                                </h5>
                                <div className="mt-4">
                                    <a href={process.env.PUBLIC_URL + "/assets/docs/store-sample-csv.csv"} download="store-sample-csv.csv" type="button" target="_blank"
                                        class="btn btn-outline btn-outline-dashed btn-outline-dark" >
                                        Download Sample CSV <i class="bi bi-cloud-download-fill text-dark fs-3"></i>
                                    </a>
                                </div>
                                <div className="mt-4">
                                    <Form className="row gy-4" onSubmit={(e) => onFormBulkUpload(e)} encType="multipart/form-data">
                                        <Col md="12">
                                            <FormGroup>
                                                <label className="form-label">CSV File : </label>
                                                <input
                                                    className="form-control"
                                                    type="file"
                                                    name="file"
                                                    accept=".csv"
                                                    onChange={(e) => handleFileInput(e.target.files[0])}
                                                    required
                                                />

                                            </FormGroup>
                                        </Col>
                                        <div>
                                            {bulkHasNoData ? <span style={{ color: 'red' }}> No Data in This File </span> : null}
                                        </div>
                                        <Col md="12">
                                            <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                                <li>
                                                    <Button type="submit" color="primary" size="lg" className="btn-block">
                                                        Upload
                                                    </Button>
                                                </li>
                                                <li>
                                                    <a
                                                        href="#cancel"
                                                        onClick={(ev) => {
                                                            ev.preventDefault();
                                                            onFormCancel();
                                                        }}
                                                        className="link link-light"
                                                    >
                                                        Cancel
                                                    </a>
                                                </li>
                                            </ul>
                                        </Col>
                                    </Form>
                                </div>

                            </div>
                        </ModalBody>
                    </Modal>

                </React.Fragment>
            }
        </React.Fragment>
    )
}

export default Stores
